import Config from './types'

export default require(`./${process.env.REACT_APP_BUILD_ENV}.ts`)
  .default as Config
